import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { BackdropController } from 'providers/backdrop-controller';

@Component({
    selector: 'cs-backdrop',
    templateUrl: 'cs-backdrop.html',
    host: { 'class': 'backdrop' },
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsBackdropComponent {
  @ViewChild('cover') backdrop: ElementRef;
  active = false;
  fadeout = false;
  clickable = true; // temporarily disable backdrop clicks while still appearing
  invisible = false; // make backdrop invisible (for tooltips, etc)

  constructor(
    private backdropCtrl: BackdropController,
    private cdr: ChangeDetectorRef
  ) {
    this.backdropCtrl.registerHost(this);
  }

  setActive(active: boolean) {
    this.active = active;
    if (active) {
      this.clickable = false;
      setTimeout(() => {
        this.clickable = true;
        this.cdr.markForCheck();
      }, 300);
    }
    this.cdr.markForCheck();
  }

  setFadeout(fadeout: boolean) {
    this.fadeout = fadeout;
    this.cdr.markForCheck();
  }

  setInvisible(invisible: boolean) {
    this.invisible = invisible;
    this.cdr.markForCheck();
  }

  onCoverClicked(event: Event) {
    if (!this.clickable || event.target !== this.backdrop.nativeElement || (this.backdropCtrl.options.disableDismissOnClick)) {
      return;
    }
    void event;
    this.backdropCtrl.onCoverClicked();
  }
}
